import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils.js';
const variantStyles = {
    default: 'bg-blue-600 text-white hover:bg-blue-700',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
    outline: 'border border-gray-300 bg-white text-gray-900 hover:bg-gray-50',
    ghost: 'bg-transparent text-gray-900 hover:bg-gray-100',
};
const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
};
export const Button = React.forwardRef(({ className, variant = 'default', size = 'md', ...props }, ref) => {
    return (_jsx("button", { ref: ref, className: cn('inline-flex items-center justify-center rounded-md font-medium transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500', 'disabled:opacity-50 disabled:pointer-events-none', variantStyles[variant], sizeStyles[size], className), ...props }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map